import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { auth } from '@/shared/api/graphqlClient';

// Role-based login pages
const LOGIN_PAGES = {
  ADMIN: '/AdminLogin',
  STAFF_ADMIN: '/AdminLogin',
  ENGINE: '/EngineLogin',
  STAFF_ENGINE: '/EngineLogin',
  RESELLER: '/ResellerLogin',
  STAFF_RESELLER: '/ResellerLogin',
  MERCHANT: '/MerchantLogin',
  STAFF_MERCHANT: '/MerchantLogin',
};

// Role-based dashboard pages
const DASHBOARD_PAGES = {
  ADMIN: '/AdminDashboard',
  STAFF_ADMIN: '/AdminDashboard',
  ENGINE: '/EngineDashboard',
  STAFF_ENGINE: '/EngineDashboard',
  RESELLER: '/ResellerDashboard',
  STAFF_RESELLER: '/ResellerDashboard',
  MERCHANT: '/MerchantDashboard',
  STAFF_MERCHANT: '/MerchantDashboard',
};

/**
 * ProtectedRoute component that handles authentication and role-based access control
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if authorized
 * @param {string[]} props.allowedRoles - Array of roles that can access this route (e.g., ['ADMIN', 'ENGINE'])
 * @param {boolean} props.requireAuth - Whether authentication is required (default: true)
 */
function ProtectedRouteContent({ children, allowedRoles = [], requireAuth = true }) {
  const location = useLocation();
  const isAuthenticated = auth.isAuthenticated();
  const userRole = auth.getUserRole()?.toUpperCase() || null;

  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (isAuthenticated) {
    const loginPages = Object.values(LOGIN_PAGES);
    const isLoginPage = loginPages.includes(location.pathname) || location.pathname === '/';

    if (isLoginPage) {
      const userDashboard = DASHBOARD_PAGES[userRole] || DASHBOARD_PAGES.ADMIN;
      return <Navigate to={userDashboard} replace />;
    }
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    const userDashboard = DASHBOARD_PAGES[userRole] || LOGIN_PAGES.ADMIN;
    return <Navigate to={userDashboard} replace />;
  }

  return <>{children}</>;
}

export default function ProtectedRoute(props) {
  return (
    <ProtectedRouteContent {...props} />
  );
}





